module.exports = __webpack_public_path__ + "img/arrow-right-landing.13965952.svg";